import {Node} from 'react-flow-renderer';
import {WorkspaceElementData} from '../components/workspace-view';

const createDraftId = (): string => `draft-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;

export const createDraftWorkspaceNode = (
  isVirtual: boolean,
  x: number = 0,
  y: number = 0,
  rotateDegree: number = 0,
  isViewMode: boolean = false,
): Node<WorkspaceElementData> => {
  const draftId = createDraftId();

  return {
    id: draftId,
    type: 'workspaces',
    dragHandle: '.workspaces',
    selectable: true,
    draggable: !isViewMode,
    position: {x, y},
    data: {
      id: draftId,
      status: isVirtual ? 'Remote' : 'Free',
      width: 100,
      height: 50,
      rotateDegree,
      coordinates: [[x + 50, y + 25]],
      room: null,
      number: null,
      employee: null,
      range: null,
      bookedStatus: [],
      comment: null,
      type: 'workspaces',
      activeRequests: [],
      isViewMode,
      isDraft: true,
      isSaving: false,
    } as WorkspaceElementData,
  };
};
